/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as protectedRouteRouteImport } from './routes/(protected)/route'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authVerifyEmailRouteImport } from './routes/(auth)/verify-email'
import { Route as protectedDashboardRouteImport } from './routes/(protected)/dashboard'
import { Route as protectedJobsRouteImport } from './routes/(protected)/jobs'
import { Route as protectedDiscoveryDiscoveryIdRouteImport } from './routes/(protected)/discovery/$discoveryId'
import { Route as protectedGenerationJobIdRouteImport } from './routes/(protected)/generation/$jobId'
import { Route as protectedSettingsIndexRouteImport } from './routes/(protected)/settings/index'
import { Route as protectedSettingsAccountRouteImport } from './routes/(protected)/settings/account'
import { Route as protectedSettingsApiKeysRouteImport } from './routes/(protected)/settings/api-keys'
import { Route as protectedSettingsBillingRouteImport } from './routes/(protected)/settings/billing'
import { Route as protectedSettingsInvoicesRouteImport } from './routes/(protected)/settings/invoices'
import { Route as protectedSettingsReferralsRouteImport } from './routes/(protected)/settings/referrals'
import { Route as protectedSettingsTaxRouteImport } from './routes/(protected)/settings/tax'
import { Route as protectedSitesIndexRouteImport } from './routes/(protected)/sites/index'
import { Route as protectedSitesSiteIdRouteImport } from './routes/(protected)/sites/$siteId'
import { Route as protectedSitesNewRouteImport } from './routes/(protected)/sites/new'
import { Route as protectedSitesSiteIdAuditRouteImport } from './routes/(protected)/sites/$siteId_/audit'
import { Route as protectedSitesNewOptionsRouteImport } from './routes/(protected)/sites/new/options'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedRouteRoute = protectedRouteRouteImport.update({
  id: '/(protected)',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => authRouteRoute,
} as any)
const protectedDashboardRoute = protectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedJobsRoute = protectedJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedDiscoveryDiscoveryIdRoute =
  protectedDiscoveryDiscoveryIdRouteImport.update({
    id: '/discovery/$discoveryId',
    path: '/discovery/$discoveryId',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedGenerationJobIdRoute =
  protectedGenerationJobIdRouteImport.update({
    id: '/generation/$jobId',
    path: '/generation/$jobId',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSettingsIndexRoute = protectedSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedSettingsAccountRoute =
  protectedSettingsAccountRouteImport.update({
    id: '/settings/account',
    path: '/settings/account',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSettingsApiKeysRoute =
  protectedSettingsApiKeysRouteImport.update({
    id: '/settings/api-keys',
    path: '/settings/api-keys',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSettingsBillingRoute =
  protectedSettingsBillingRouteImport.update({
    id: '/settings/billing',
    path: '/settings/billing',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSettingsInvoicesRoute =
  protectedSettingsInvoicesRouteImport.update({
    id: '/settings/invoices',
    path: '/settings/invoices',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSettingsReferralsRoute =
  protectedSettingsReferralsRouteImport.update({
    id: '/settings/referrals',
    path: '/settings/referrals',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSettingsTaxRoute = protectedSettingsTaxRouteImport.update({
  id: '/settings/tax',
  path: '/settings/tax',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedSitesIndexRoute = protectedSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedSitesSiteIdRoute = protectedSitesSiteIdRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedSitesNewRoute = protectedSitesNewRouteImport.update({
  id: '/sites/new',
  path: '/sites/new',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedSitesSiteIdAuditRoute =
  protectedSitesSiteIdAuditRouteImport.update({
    id: '/sites/$siteId_/audit',
    path: '/sites/$siteId/audit',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSitesNewOptionsRoute =
  protectedSitesNewOptionsRouteImport.update({
    id: '/options',
    path: '/options',
    getParentRoute: () => protectedSitesNewRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/reset-password': typeof authResetPasswordRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/dashboard': typeof protectedDashboardRoute
  '/jobs': typeof protectedJobsRoute
  '/discovery/$discoveryId': typeof protectedDiscoveryDiscoveryIdRoute
  '/generation/$jobId': typeof protectedGenerationJobIdRoute
  '/settings/account': typeof protectedSettingsAccountRoute
  '/settings/api-keys': typeof protectedSettingsApiKeysRoute
  '/settings/billing': typeof protectedSettingsBillingRoute
  '/settings/invoices': typeof protectedSettingsInvoicesRoute
  '/settings/referrals': typeof protectedSettingsReferralsRoute
  '/settings/tax': typeof protectedSettingsTaxRoute
  '/sites/$siteId': typeof protectedSitesSiteIdRoute
  '/sites/new': typeof protectedSitesNewRouteWithChildren
  '/settings/': typeof protectedSettingsIndexRoute
  '/sites/': typeof protectedSitesIndexRoute
  '/sites/$siteId/audit': typeof protectedSitesSiteIdAuditRoute
  '/sites/new/options': typeof protectedSitesNewOptionsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/reset-password': typeof authResetPasswordRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/dashboard': typeof protectedDashboardRoute
  '/jobs': typeof protectedJobsRoute
  '/discovery/$discoveryId': typeof protectedDiscoveryDiscoveryIdRoute
  '/generation/$jobId': typeof protectedGenerationJobIdRoute
  '/settings/account': typeof protectedSettingsAccountRoute
  '/settings/api-keys': typeof protectedSettingsApiKeysRoute
  '/settings/billing': typeof protectedSettingsBillingRoute
  '/settings/invoices': typeof protectedSettingsInvoicesRoute
  '/settings/referrals': typeof protectedSettingsReferralsRoute
  '/settings/tax': typeof protectedSettingsTaxRoute
  '/sites/$siteId': typeof protectedSitesSiteIdRoute
  '/sites/new': typeof protectedSitesNewRouteWithChildren
  '/settings': typeof protectedSettingsIndexRoute
  '/sites': typeof protectedSitesIndexRoute
  '/sites/$siteId/audit': typeof protectedSitesSiteIdAuditRoute
  '/sites/new/options': typeof protectedSitesNewOptionsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth)': typeof authRouteRouteWithChildren
  '/(protected)': typeof protectedRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/(protected)/dashboard': typeof protectedDashboardRoute
  '/(protected)/jobs': typeof protectedJobsRoute
  '/(protected)/discovery/$discoveryId': typeof protectedDiscoveryDiscoveryIdRoute
  '/(protected)/generation/$jobId': typeof protectedGenerationJobIdRoute
  '/(protected)/settings/account': typeof protectedSettingsAccountRoute
  '/(protected)/settings/api-keys': typeof protectedSettingsApiKeysRoute
  '/(protected)/settings/billing': typeof protectedSettingsBillingRoute
  '/(protected)/settings/invoices': typeof protectedSettingsInvoicesRoute
  '/(protected)/settings/referrals': typeof protectedSettingsReferralsRoute
  '/(protected)/settings/tax': typeof protectedSettingsTaxRoute
  '/(protected)/sites/$siteId': typeof protectedSitesSiteIdRoute
  '/(protected)/sites/new': typeof protectedSitesNewRouteWithChildren
  '/(protected)/settings/': typeof protectedSettingsIndexRoute
  '/(protected)/sites/': typeof protectedSitesIndexRoute
  '/(protected)/sites/$siteId_/audit': typeof protectedSitesSiteIdAuditRoute
  '/(protected)/sites/new/options': typeof protectedSitesNewOptionsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/verify-email'
    | '/dashboard'
    | '/jobs'
    | '/discovery/$discoveryId'
    | '/generation/$jobId'
    | '/settings/account'
    | '/settings/api-keys'
    | '/settings/billing'
    | '/settings/invoices'
    | '/settings/referrals'
    | '/settings/tax'
    | '/sites/$siteId'
    | '/sites/new'
    | '/settings/'
    | '/sites/'
    | '/sites/$siteId/audit'
    | '/sites/new/options'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/verify-email'
    | '/dashboard'
    | '/jobs'
    | '/discovery/$discoveryId'
    | '/generation/$jobId'
    | '/settings/account'
    | '/settings/api-keys'
    | '/settings/billing'
    | '/settings/invoices'
    | '/settings/referrals'
    | '/settings/tax'
    | '/sites/$siteId'
    | '/sites/new'
    | '/settings'
    | '/sites'
    | '/sites/$siteId/audit'
    | '/sites/new/options'
  id:
    | '__root__'
    | '/'
    | '/(auth)'
    | '/(protected)'
    | '/(auth)/forgot-password'
    | '/(auth)/reset-password'
    | '/(auth)/verify-email'
    | '/(protected)/dashboard'
    | '/(protected)/jobs'
    | '/(protected)/discovery/$discoveryId'
    | '/(protected)/generation/$jobId'
    | '/(protected)/settings/account'
    | '/(protected)/settings/api-keys'
    | '/(protected)/settings/billing'
    | '/(protected)/settings/invoices'
    | '/(protected)/settings/referrals'
    | '/(protected)/settings/tax'
    | '/(protected)/sites/$siteId'
    | '/(protected)/sites/new'
    | '/(protected)/settings/'
    | '/(protected)/sites/'
    | '/(protected)/sites/$siteId_/audit'
    | '/(protected)/sites/new/options'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authRouteRoute: typeof authRouteRouteWithChildren
  protectedRouteRoute: typeof protectedRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)': {
      id: '/(protected)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof protectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(protected)/dashboard': {
      id: '/(protected)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof protectedDashboardRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/jobs': {
      id: '/(protected)/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof protectedJobsRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/discovery/$discoveryId': {
      id: '/(protected)/discovery/$discoveryId'
      path: '/discovery/$discoveryId'
      fullPath: '/discovery/$discoveryId'
      preLoaderRoute: typeof protectedDiscoveryDiscoveryIdRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/generation/$jobId': {
      id: '/(protected)/generation/$jobId'
      path: '/generation/$jobId'
      fullPath: '/generation/$jobId'
      preLoaderRoute: typeof protectedGenerationJobIdRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/': {
      id: '/(protected)/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof protectedSettingsIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/account': {
      id: '/(protected)/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof protectedSettingsAccountRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/api-keys': {
      id: '/(protected)/settings/api-keys'
      path: '/settings/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof protectedSettingsApiKeysRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/billing': {
      id: '/(protected)/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof protectedSettingsBillingRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/invoices': {
      id: '/(protected)/settings/invoices'
      path: '/settings/invoices'
      fullPath: '/settings/invoices'
      preLoaderRoute: typeof protectedSettingsInvoicesRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/referrals': {
      id: '/(protected)/settings/referrals'
      path: '/settings/referrals'
      fullPath: '/settings/referrals'
      preLoaderRoute: typeof protectedSettingsReferralsRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/tax': {
      id: '/(protected)/settings/tax'
      path: '/settings/tax'
      fullPath: '/settings/tax'
      preLoaderRoute: typeof protectedSettingsTaxRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/sites/': {
      id: '/(protected)/sites/'
      path: '/sites'
      fullPath: '/sites/'
      preLoaderRoute: typeof protectedSitesIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/sites/$siteId': {
      id: '/(protected)/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof protectedSitesSiteIdRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/sites/new': {
      id: '/(protected)/sites/new'
      path: '/sites/new'
      fullPath: '/sites/new'
      preLoaderRoute: typeof protectedSitesNewRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/sites/$siteId_/audit': {
      id: '/(protected)/sites/$siteId_/audit'
      path: '/sites/$siteId/audit'
      fullPath: '/sites/$siteId/audit'
      preLoaderRoute: typeof protectedSitesSiteIdAuditRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/sites/new/options': {
      id: '/(protected)/sites/new/options'
      path: '/options'
      fullPath: '/sites/new/options'
      preLoaderRoute: typeof protectedSitesNewOptionsRouteImport
      parentRoute: typeof protectedSitesNewRoute
    }
  }
}

interface authRouteRouteChildren {
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authForgotPasswordRoute: authForgotPasswordRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface protectedSitesNewRouteChildren {
  protectedSitesNewOptionsRoute: typeof protectedSitesNewOptionsRoute
}

const protectedSitesNewRouteChildren: protectedSitesNewRouteChildren = {
  protectedSitesNewOptionsRoute: protectedSitesNewOptionsRoute,
}

const protectedSitesNewRouteWithChildren =
  protectedSitesNewRoute._addFileChildren(protectedSitesNewRouteChildren)

interface protectedRouteRouteChildren {
  protectedDashboardRoute: typeof protectedDashboardRoute
  protectedJobsRoute: typeof protectedJobsRoute
  protectedDiscoveryDiscoveryIdRoute: typeof protectedDiscoveryDiscoveryIdRoute
  protectedGenerationJobIdRoute: typeof protectedGenerationJobIdRoute
  protectedSettingsAccountRoute: typeof protectedSettingsAccountRoute
  protectedSettingsApiKeysRoute: typeof protectedSettingsApiKeysRoute
  protectedSettingsBillingRoute: typeof protectedSettingsBillingRoute
  protectedSettingsInvoicesRoute: typeof protectedSettingsInvoicesRoute
  protectedSettingsReferralsRoute: typeof protectedSettingsReferralsRoute
  protectedSettingsTaxRoute: typeof protectedSettingsTaxRoute
  protectedSitesSiteIdRoute: typeof protectedSitesSiteIdRoute
  protectedSitesNewRoute: typeof protectedSitesNewRouteWithChildren
  protectedSettingsIndexRoute: typeof protectedSettingsIndexRoute
  protectedSitesIndexRoute: typeof protectedSitesIndexRoute
  protectedSitesSiteIdAuditRoute: typeof protectedSitesSiteIdAuditRoute
}

const protectedRouteRouteChildren: protectedRouteRouteChildren = {
  protectedDashboardRoute: protectedDashboardRoute,
  protectedJobsRoute: protectedJobsRoute,
  protectedDiscoveryDiscoveryIdRoute: protectedDiscoveryDiscoveryIdRoute,
  protectedGenerationJobIdRoute: protectedGenerationJobIdRoute,
  protectedSettingsAccountRoute: protectedSettingsAccountRoute,
  protectedSettingsApiKeysRoute: protectedSettingsApiKeysRoute,
  protectedSettingsBillingRoute: protectedSettingsBillingRoute,
  protectedSettingsInvoicesRoute: protectedSettingsInvoicesRoute,
  protectedSettingsReferralsRoute: protectedSettingsReferralsRoute,
  protectedSettingsTaxRoute: protectedSettingsTaxRoute,
  protectedSitesSiteIdRoute: protectedSitesSiteIdRoute,
  protectedSitesNewRoute: protectedSitesNewRouteWithChildren,
  protectedSettingsIndexRoute: protectedSettingsIndexRoute,
  protectedSitesIndexRoute: protectedSitesIndexRoute,
  protectedSitesSiteIdAuditRoute: protectedSitesSiteIdAuditRoute,
}

const protectedRouteRouteWithChildren = protectedRouteRoute._addFileChildren(
  protectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authRouteRoute: authRouteRouteWithChildren,
  protectedRouteRoute: protectedRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
